import React from 'react'
import ReactDOM from 'react-dom'

import PreferenceBar from './PreferenceBar.jsx'

import './index.css'

class PreferenceBarElement extends HTMLElement {
  connectedCallback() {
    let stamp = Math.floor(Math.random() * 10000)
    const reactContainerId = `preference-bar-react-app${stamp}`
    const reactContainer = document.createElement('div')
    reactContainer.setAttribute('id', reactContainerId)
    this.appendChild(reactContainer)

    const site = this.getAttribute('site')

    ReactDOM.render(
      <PreferenceBar site={site} />,
      document.getElementById(reactContainerId)
    )
  }
}

customElements.define('preference-bar', PreferenceBarElement)
